import type { InviteEligibilityOutcome } from '@/modules/application-tracker/api';

export type InviteEligibilityBannerVariant = 'warning' | 'block';

export type InviteEligibilityBannerContent = {
  variant: InviteEligibilityBannerVariant;
  title: string;
  body: string;
  ctaLabel: string;
};

/**
 * Which banner (and its copy) comes from `outcome` only — plus `total_matches` for the
 * warning title count. Ignore `matches[]`; the server already decided allow/warning/block.
 * `reason` is accepted for future copy variants but is unused today.
 */
export const getInviteEligibilityBannerContent = ({
  outcome,
  totalMatches,
}: {
  outcome: InviteEligibilityOutcome;
  totalMatches?: number;
  reason?: string;
}): InviteEligibilityBannerContent | null => {
  if (outcome === 'warning') {
    const count = totalMatches ?? 0;
    return {
      variant: 'warning',
      title: `${count} application(s) matching this email`,
      body: 'Review before proceeding to send new invite.',
      ctaLabel: 'Review',
    };
  }

  if (outcome === 'block') {
    return {
      variant: 'block',
      title: 'An application already exists for this applicant with the lease details provided.',
      body: 'View and edit the existing application details to proceed with this applicant.',
      ctaLabel: 'View',
    };
  }

  return null;
};
